import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLogs } from '../actions/logs';

export const useLogsPagination = () => {
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({});
  const dispatch = useDispatch();
  const pageSize = 10;

  // Obtener el estado de Redux
  const logsState = useSelector(state => state.logsReducer);
  const { logs, total, loading, error } = logsState;

  // Logs de depuración (comentados para producción)
  // useEffect(() => {
  //   console.log('useLogsPagination mounted or updated');
  //   console.log('Current state:', { logs, total, loading, error, page, filters });
  // }, [logs, total, loading, error, page, filters]);

  useEffect(() => {
    // console.log('useLogsPagination effect triggered - loadLogs');
    loadLogs();
  }, [page, filters]);

  const loadLogs = () => {
    const offset = (page - 1) * pageSize;
    dispatch(fetchLogs(pageSize, offset, filters));
  };

  const handlePageChange = (newPage) => {
    // console.log('Page changed to:', newPage);
    setPage(newPage);
  };

  const handleFilterChange = (newFilters) => {
    // console.log('Filters changed to:', newFilters);
    setFilters(newFilters);
    setPage(1); // Reset to first page when filters change
  };

  const clearFilters = () => {
    // console.log('Clearing filters');
    setFilters({});
    setPage(1);
  };

  return {
    logs,
    total,
    loading,
    error,
    page,
    pageSize,
    filters,
    handlePageChange,
    handleFilterChange,
    clearFilters,
    loadLogs
  };
};
